import { render, staticRenderFns } from "./Declutters.vue?vue&type=template&id=359ed7ae&"
import script from "./Declutters.vue?vue&type=script&lang=js&"
export * from "./Declutters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports